// Cardápio do TOTEM (o Balcão tem o seu: TelaCardapioBalcao): banner ocupando o cabeçalho inteiro (acima da
// coluna também), coluna de categorias (busca primeiro, SAIR embaixo), faixa
// com cliente/carteira/cashback à esquerda (sem título de categoria — a marca
// na coluna já destaca), grade de produtos ou painel de busca, barra do
// carrinho, popup de produto e gaveta.
import { Search, ShoppingCart } from "lucide-react";

import { CarregandoGrade } from "../../../components/carregando";

import AnimacaoAdicionado from "../components/AnimacaoAdicionado";
import BannerCardapio from "../components/BannerCardapio";
import BuscaProdutos from "../components/BuscaProdutos";
import CardProduto from "../components/CardProduto";
import CarrinhoSheet from "../components/CarrinhoSheet";
import ColunaCategorias from "../components/ColunaCategorias";
import FaixaCliente from "../components/FaixaCliente";
import { fmt } from "../lib/helpers";
import PopupProduto from "../popup-produto/PopupProduto";
import { useMidiasPublicas } from "../../produto-midias";

export default function TelaCardapio({ ctx }) {
  // Fotos extras e vídeo dos produtos: no Totem sim, no Balcão não (23/10/2026)
  const midiasProdutos = useMidiasPublicas();
  const {
    telaCls, popupBoasVindas, setScreen, cashbackAtivo, cashbackCfg, autoAtendimento,
    buscaAberta, setBuscaAberta, searchTerm, setSearchTerm, primeiraCarga, filteredProducts,
    getProductPromo, abrirProduto, cartCount, cartTotal, setCartOpen, selectedProduct, popupOpen, setPopupOpen,
    addToCart, allProductsForPhotos, products, promotions, pizza, addedAnim, lerCodigo,
  } = ctx;

  return (
    <div className={`${telaCls} bg-zinc-950 flex flex-col select-none`}>
      {popupBoasVindas}
      {/* Banner só no TOTEM — no balcão (venda rápida) o atendente não precisa de marketing na tela */}
      {autoAtendimento && <BannerCardapio />}

      <div className="flex-1 flex min-h-0">
        <ColunaCategorias ctx={ctx} />

        <div className="flex-1 flex flex-col min-w-0">
        <FaixaCliente ctx={ctx} />

        {buscaAberta && (
          <BuscaProdutos searchTerm={searchTerm} setSearchTerm={setSearchTerm} total={filteredProducts.length} onCodigo={lerCodigo} onFechar={() => { setBuscaAberta(false); setSearchTerm(""); }} />
        )}

        <div className="flex-1 overflow-y-auto px-4 py-4">
          {primeiraCarga ? (
            <div className="dark"><CarregandoGrade comImagem quantos={10} className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3" /></div>
          ) : filteredProducts.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-64 text-zinc-400"><Search className="w-12 h-12 mb-3" /><p className="text-lg">Nenhum produto encontrado</p></div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
              {filteredProducts.map((p) => (
                <CardProduto key={p.id} product={p} promo={getProductPromo(p)} cashbackPct={cashbackAtivo && !getProductPromo(p) ? cashbackCfg?.percentual : null} onClick={() => abrirProduto(p)} midias={midiasProdutos[p.id]} />
              ))}
            </div>
          )}
        </div>

        {cartCount > 0 && (
          <div className="bg-zinc-900 border-t border-zinc-800 px-4 py-3 flex items-center gap-3">
            <button onClick={() => setCartOpen(true)} className="flex-1 flex items-center justify-between bg-zinc-800 rounded-xl px-4 py-3 hover:bg-zinc-700 transition-colors">
              <div className="flex items-center gap-3">
                <div className="relative">
                  <ShoppingCart className="w-6 h-6 text-orange-500" />
                  <span className="absolute -top-2 -right-2 w-5 h-5 bg-orange-500 text-white text-xs font-bold rounded-full flex items-center justify-center">{cartCount}</span>
                </div>
                <span className="text-zinc-100 font-medium">Ver Carrinho</span>
              </div>
              <span className="text-lg font-bold text-orange-500">R$ {fmt(cartTotal)}</span>
            </button>
            <button onClick={() => setScreen("cart_review")} className="px-8 py-3 bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg rounded-xl transition-all shadow-lg active:scale-95">
              Finalizar
            </button>
          </div>
        )}
        </div>
      </div>

      <PopupProduto modulo="Totem" midias={midiasProdutos[selectedProduct?.id]} product={selectedProduct} open={popupOpen} onClose={() => setPopupOpen(false)} onAddToCart={addToCart} allProducts={allProductsForPhotos.length > 0 ? allProductsForPhotos : products} activePromotions={promotions} />
      {pizza.popup}
      <CarrinhoSheet ctx={ctx} />
      <AnimacaoAdicionado addedAnim={addedAnim} />
    </div>
  );
}
